export default function SuitCaseIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.373 6.817C3.26 5.765 4.777 5.25 7 5.25h10c2.223 0 3.74.515 4.626 1.567.877 1.043.96 2.412.82 3.69l-.75 8.003c-.11 1.028-.369 2.155-1.287 2.994-.91.832-2.322 1.246-4.41 1.246H8c-2.086 0-3.498-.414-4.409-1.246-.918-.839-1.176-1.966-1.286-2.994l-.001-.01-.75-7.994c-.14-1.277-.056-2.646.82-3.689zm1.148.966c-.471.56-.604 1.403-.476 2.564l.002.013.749 7.995c.1.93.307 1.586.806 2.041.506.463 1.465.854 3.398.854h8c1.933 0 2.891-.391 3.398-.854.498-.455.706-1.112.805-2.041l.751-8.008c.129-1.16-.004-2.003-.476-2.564C20.014 7.23 19.047 6.75 17 6.75H7c-2.047 0-3.014.48-3.479 1.033z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.794 4.05c-.043.326-.044.696-.044 1.15V6a.75.75 0 11-1.5 0v-.826c0-.424 0-.886.056-1.318.059-.447.184-.922.477-1.346C8.4 1.617 9.53 1.25 11.2 1.25h1.6c1.67 0 2.8.367 3.417 1.26.293.424.418.899.477 1.346.056.432.056.894.056 1.318V6a.75.75 0 01-1.5 0v-.8c0-.454-.001-.824-.044-1.15-.041-.318-.116-.533-.223-.687-.183-.265-.654-.613-2.183-.613h-1.6c-1.53 0-2 .348-2.183.613-.107.154-.182.369-.223.687zm1.956 8.7v1.28c0 .282.002.489.027.664.023.17.06.251.092.296.036.05.212.26 1.131.26.924 0 1.097-.212 1.132-.261.032-.046.069-.13.092-.3.024-.178.026-.386.026-.669v-1.27h-2.5zm.217-1.5h2.066c.221 0 .445 0 .628.02.186.02.496.076.744.325.249.248.304.558.325.744.02.183.02.407.02.628v1.064c0 .26 0 .567-.04.859-.04.302-.13.646-.35.959-.467.668-1.294.901-2.36.901-1.06 0-1.885-.23-2.354-.893a2.134 2.134 0 01-.355-.956 6.4 6.4 0 01-.041-.871v-1.063c0-.221 0-.445.02-.628.02-.186.076-.496.325-.744.248-.249.558-.304.744-.325.183-.02.407-.02.628-.02z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22.256 10.559a.75.75 0 01-.165 1.048 17.234 17.234 0 01-7.998 3.157.75.75 0 01-.187-1.488 15.735 15.735 0 007.303-2.883.75.75 0 011.047.166zM2 10.847a.75.75 0 011.043-.196 15.533 15.533 0 007.04 2.634.75.75 0 01-.167 1.49 17.033 17.033 0 01-7.72-2.886.75.75 0 01-.195-1.042z"
        clipRule="evenodd"
      />
    </svg>
  );
}
